// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1tH-T","file":"styles_file__34rEF"};